import React, { useState } from "react";
import { objectSelector } from "../../utils";
import Agreement from "plugins/tfs/pages/checkout/agreement";
import giftIcon from "theme/svg/gift-logo.svg";

import "../FundTransfer/style.less";

const {
  DIRECTORY_THEME: { FUND_TRANSFER_SELECTION },
} = require(`plugins/tfs/platformConfigs/staticTextMaps/checkout`);

function FundTransferTFS({
  options = [],
  onCancel = () => {},
  onPayWithFundTransfer = () => {},
  onFundsTransferChoicePage = () => {},
  error = null,
}) {
  const [isCheckAgreement, setIsCheckAgreement] = useState(false);

  const onAgreement = () => {
    setIsCheckAgreement((prev) => !prev);
    if (!isCheckAgreement) {
      onFundsTransferChoicePage(objectSelector(options, `${[0]}.pk`));
    }
  };

  const handlePayment = () => {
    onPayWithFundTransfer(isCheckAgreement);
  };

  const isPlaceOrderButtonDisabled = !isCheckAgreement;

  return (
    <div className="payment-lock-screen checkout-funds-transfer-modal">
      <div className="barcode-box">
        <p className="checkout-funds-transfer-modal-header">
          <img
            src={giftIcon}
            className="checkout-funds-transfer-modal-icon"
            alt="gift-icon"
          />
          <span>{FUND_TRANSFER_SELECTION.HEADER}</span>
        </p>
        <div className="checkout-funds-transfer-modal-agreement">
          <Agreement
            agreementType="fundTransfer"
            onAgreement={onAgreement}
            checked={isCheckAgreement}
            error={error}
          />
        </div>
        <div className="checkout-funds-transfer-modal-actions">
          <button className="ok-button" onClick={onCancel}>
            {FUND_TRANSFER_SELECTION.CANCEL_BUTTON}
          </button>
          <button
            disabled={isPlaceOrderButtonDisabled}
            className="ok-button"
            onClick={handlePayment}
          >
            {FUND_TRANSFER_SELECTION.PLACE_ORDER_BUTTON}
          </button>
        </div>
      </div>
    </div>
  );
}

export default FundTransferTFS;



// WEBPACK FOOTER //
// ./src/theme/checkout/tfs/FundTransferTFS.js